import React, { memo, useState, useCallback } from 'react';

import { gray } from 'utils/style/colors';

import {
  HorizontalCollapsibleContainer,
  HorizontalCollapsibleHeader,
} from './styles';
import IconTypes from 'components/Icon/IconTypes';
import HorizontalCollapsibleBody from './CollapsibleBody/HorizontalCollapsibleBody';

interface ICollapsibleProps {
  headerBackgroundColor?: string;
  bordered?: boolean;
  children: React.ReactNode;
  customHeaderStyle?: React.CSSProperties;
  headerContentColor?: string;
  defaultOpen?: boolean;
  isOpen?: boolean;
  noZ?: boolean;
  iconName?: IconTypes;
  onOpen?: () => any;
  onClose?: () => any;
  header: React.ReactElement | string;
  customBodyStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  customCollapsibleHeaderStyle?: React.CSSProperties;
  checkHeightAgain?: number;
  headerWrapperPadding?: string;
  nested?: boolean;
  noColor?: boolean;
  arrowLocation?: 'start' | 'end';
  hideChevron?: boolean;
}

const HorizontalCollapsible: React.FC<ICollapsibleProps> = ({
  headerBackgroundColor = 'transparent',
  bordered = true,
  children,
  headerContentColor = gray,
  defaultOpen = false,
  header,
  isOpen,
  onOpen,
  customBodyStyle,
  headerWrapperPadding,
  style,
  nested,
  noZ,
  customCollapsibleHeaderStyle,
  onClose,
  noColor,
}) => {
  const [stateIsOpen, setOpen] = useState<boolean>(defaultOpen || false);

  const toggleCollapseCallback = useCallback(() => {
    setOpen((prevIsOpen) => {
      const newIsOpen = !prevIsOpen;
      if (newIsOpen) onOpen && onOpen();
      else onClose && onClose();
      return newIsOpen;
    });
  }, [onOpen, onClose]);

  const finalIsOpen = isOpen === undefined ? stateIsOpen! : isOpen;
  return (
    <HorizontalCollapsibleContainer
      isOpen={isOpen}
      style={style}
      noZ={noZ}
      noColor={noColor}
    >
      <HorizontalCollapsibleHeader
        noColor={noColor}
        backgroundColor={headerBackgroundColor}
        headerWrapperPadding={headerWrapperPadding}
        bordered={bordered}
        contentColor={headerContentColor}
        isOpen={finalIsOpen}
        onClick={toggleCollapseCallback}
        style={customCollapsibleHeaderStyle}
      >
        {header}
      </HorizontalCollapsibleHeader>
      <HorizontalCollapsibleBody
        isOpen={finalIsOpen}
        customBodyStyle={customBodyStyle}
        nested={nested}
      >
        {children}
      </HorizontalCollapsibleBody>
    </HorizontalCollapsibleContainer>
  );
};

export default memo(HorizontalCollapsible);
